export const LEAGUE_NAMES = {
    CL: 'Champions League',
    PL: 'Premier League',
    BL1: 'Bundesliga',
    SA: 'Serie A',
    PD: 'La Liga',
    FL1: 'Ligue 1',
    PPL: 'Primeira Liga',
};
